export default "__VITE_ASSET__kMkN_OHP__"